// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function readAllWarehouses(query) {
    let baseUrl = config.WAREHOUSES_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`, {});
}

function createWarehouse(warehouseRequest) {
    const baseUrl = config.WAREHOUSES_URL;
    return api.create(`${baseUrl}`, warehouseRequest);
}

function updateWarehouse(warehouseId, warehouseRequest) {
    const baseUrl = config.WAREHOUSES_URL + '/' + warehouseId;
    return api.update(`${baseUrl}`, warehouseRequest);
}

function deleteWarehouse(warehouseId) {
    const baseUrl = config.WAREHOUSES_URL + '/' + warehouseId;
    return api.delete(`${baseUrl}`, {});
}

export {
    readAllWarehouses,
    createWarehouse,
    updateWarehouse,
    deleteWarehouse,
};